// Marketing homepage. Composition mirrors seidr-landing's
// app/page.tsx (commit 45d4591) — same component order, same visual.
// All 10 components were ported into ../components/ and trimmed of
// Next.js-isms ("use client", next/image).

import React from 'react';
import Nav from '../components/Nav';
import Hero from '../components/Hero';
import Marquee from '../components/Marquee';
import InteractiveFilter from '../components/InteractiveFilter';
import Bento from '../components/Bento';
import TwoVerticals from '../components/TwoVerticals';
import CTA from '../components/CTA';
import Footer from '../components/Footer';

export default function HomePage() {
  return (
    <>
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <InteractiveFilter />
        <Bento />
        <TwoVerticals />
        <CTA />
      </main>
      <Footer />
    </>
  );
}
